import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";
import { IRootState } from "../app/store";
import { selectedSpaceNumber } from "../DesignTab/designSelectors";
import { selectProjectNo } from "../globalSelectors";
import { selectUniqueMcbimSpaceNames } from "./extraMcBimSelectors";

const selectFloorAndJob = (state: IRootState) => state.design.floorAndJob;

// Bygger args för getMcbimSingleMcbimSpace baserat på aktivt room,
// utan att importera selectActiveSingleRoom (undviker cirkulär import).
export const selectGetMcbimStandardSpaceArgs = createSelector(
  [
    selectedSpaceNumber,
    selectFloorAndJob,
    selectProjectNo,
    selectUniqueMcbimSpaceNames,
    (state: IRootState) => state,
  ],
  (selectedRoomNumber, floorAndJob, projectNo, uniqueNames, state) => {
    if (!selectedRoomNumber || !floorAndJob?.jobId || !projectNo) {
      return null;
    }

    // Samma args-form som selectGetRoomsArgs
    const roomsArgs = {
      body: {
        projectNo,
        roomNumbers: uniqueNames,
      },
    };

    const roomsHashmap = openapi.endpoints.postMultiplacerRooms.select(roomsArgs)(state).data ?? {};

    const activeRoom = (roomsHashmap as Record<string, { rfpMalRom?: unknown }>)[
      selectedRoomNumber
    ];

    if (!activeRoom || activeRoom.rfpMalRom == null) {
      return null;
    }

    return {
      projectNo,
      name: activeRoom.rfpMalRom as string,
      jobId: floorAndJob.jobId,
    };
  }
);
